/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kommunikationmitul3Inputs */

const de__field_kommunikationmitul3 = /** @type {(inputs: _Field_Kommunikationmitul3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommunikation mit UL`)
};

/**

* @param {_Field_Kommunikationmitul3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kommunikationmitul3 = /** @type {((inputs?: _Field_Kommunikationmitul3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kommunikationmitul3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kommunikationmitul3(inputs)
});
export { _field_kommunikationmitul3 as "_field_kommunikationMitUL" }